<template>
    <table
        id="vuetable-sum-table"
        :class="['vuetable', css.tableClass, css.tableHeaderClass]">
        <thead>
            <tr>
                <template v-if="tablePagination && 'sum' in tablePagination">
                    <th
                        v-for="(field, fieldIndex) in tableFields"
                        :key="fieldIndex"
                        :id="`__${field.name}`"
                        :style="{width: field.width}"
                        :class="['vuetable-th-'+field.name, field.titleClass || '']">
                        <template
                            v-if="['__sequence', '__checkbox', '__component', '__slot'].indexOf(field.name) > -1 || fieldIndex === 0">
                            &Sigma;
                        </template>
                        <template v-else-if="field.name in tablePagination.sum">
                            {{ tablePagination.sum[field.name] | humanReadableNumber }}
                        </template>
                        <template v-else>SKUPAJ</template>
                    </th>
                </template>
            </tr>
        </thead>
    </table>
</template>

<script>
import VuetablePaginationInfoMixin from 'vuetable-2/src/components/VuetablePaginationInfoMixin';

export default {
    name: 'VuetableTotal',

    filters: {
        humanReadableNumber(value) {
            value = !isNaN(value) ? Number(value) : 0;
            return value.toLocaleString('sl-SI', {style: 'decimal', useGrouping: true});
        }
    },

    mixins: [VuetablePaginationInfoMixin],

    props: {
        fields: {
            type:     Array,
            required: true
        },

        css: {
            type: Object,
            default() {
                return {
                    tableClass:       'ui blue selectable celled stackable attached table',
                    loadingClass:     'loading',
                    ascendingIcon:    'blue chevron up icon',
                    descendingIcon:   'blue chevron down icon',
                    ascendingClass:   'sorted-asc',
                    descendingClass:  'sorted-desc',
                    sortableIcon:     '',
                    detailRowClass:   'vuetable-detail-row',
                    handleIcon:       'grey sidebar icon',
                    tableBodyClass:   'vuetable-semantic-no-top vuetable-fixed-layout',
                    tableHeaderClass: 'vuetable-fixed-layout'
                };
            }
        },
    },

    data() {
        return {
            tableFields:  [],
            windowHeight: 0,
            windowWidth:  0,
            oldWidths:    {},
            newWidths:    {}
        };
    },

    watch: {
        windowWidth() {
            this.equalizeWidths();
        },
    },

    mounted() {
        this.normalizeFields();

        this.$nextTick(() => {
            window.addEventListener('resize', () => {
                this.windowHeight = window.innerHeight;
                this.windowWidth = window.innerWidth;
            });
        });

        this.equalizeWidths();
    },

    methods: {
        isSpecialField(fieldName) {
            return fieldName.slice(0, 2) === '__';
        },

        titleCase(str) {
            return str.replace(/\w+/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        },

        setTitle(str) {
            if (this.isSpecialField(str)) {
                return '';
            }

            return this.titleCase(str);
        },

        normalizeFields() {
            if (typeof(this.fields) === 'undefined') {
                this.warn('You need to provide "fields" prop.');
                return;
            }

            this.tableFields = [];
            let self = this;
            let obj;
            this.fields.forEach(function (field) {
                if (typeof (field) === 'string') {
                    obj = {
                        name:       field,
                        title:      self.setTitle(field),
                        titleClass: '',
                        dataClass:  '',
                        callback:   null,
                        visible:    true,
                    };
                } else {
                    obj = {
                        name:       field.name,
                        width:      field.width,
                        title:      (field.title === undefined) ? self.setTitle(field.name) : field.title,
                        sortField:  field.sortField,
                        titleClass: (field.titleClass === undefined) ? '' : field.titleClass,
                        dataClass:  (field.dataClass === undefined) ? '' : field.dataClass,
                        callback:   (field.callback === undefined) ? '' : field.callback,
                        visible:    (field.visible === undefined) ? true : field.visible,
                    };
                }
                self.tableFields.push(obj);
            });
        },

        equalizeWidths() {
            const widthAdapt = window.setInterval(() => {
                for (let field of this.tableFields) {
                    if (
                        ['__sequence', '__checkbox', '__component', '__slot'].indexOf(field.name) === -1 &&
                            document.getElementById(`_${field.name}`)
                    ) {
                        let width = document.getElementById(`_${field.name}`).offsetWidth;

                        field.width = width + 'px';

                        this.newWidths[field.name] = width;

                        if (
                            !document.querySelectorAll('.vuetable-empty-result') &&
                            field.name in this.oldWidths &&
                            this.newWidths[field.name] === this.oldWidths[field.name]
                        ) {
                            window.clearInterval(widthAdapt);
                        }

                        this.oldWidths[field.name] = width;
                    }
                }
            }, 10);
        }
    }
};
</script>

<style lang="scss" scoped>
    #vuetable-sum-table {
        thead {
            tr {
                background-color: #f9f9f9;

                th {
                    border-top: 1px solid #f4f4f4;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/VuetableTotal.vue